import { Route } from '/@/modules/core/app/constants/api.constants';
import { Estate } from '/@/modules/estate/models/Estate';
import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';

export class EstateService extends BaseEntityService {
  getModel() {
    return Estate;
  }

  getRoute() {
    return Route.ESTATES;
  }
}

export default new EstateService();
